import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import Image from 'next/image';
import { PublicCourse } from '@cademy-package/sdk-component-types';

type EmptyListPlaceholderProps = {
    course: PublicCourse;
};

export const EmptyListPlaceholder: FunctionComponent<EmptyListPlaceholderProps> = ({ course }) => {
    return (
        <section className={styles.emptyListPlaceholder}>
            <Image
                src={`${process.env.NEXT_PUBLIC_ASSETS_URL}/images/owls/400/eyes-closed.png`}
                alt="Olly the owl closing his eyes"
                width={150}
                height={150}
                priority
            />
            <h3>No Dates To Show</h3>
            <p>{course.name} currently has no available dates.</p>
            <p>Please check back later.</p>
        </section>
    );
};
